import { useEffect, useRef } from "react";
import { getNotificationSocket } from "@/lib/notificationSocket";

export type NewNotificationSocketPayload = {
    newNotification?: boolean;
    totalUnreadNotifications?: number;
};

/**
 * Live unread badge for KITCHEN / ADMIN panels. List refetch is handled by the inbox UI, not here.
 */
export function useNotificationSocket(token: string | null, onCount: (count: number) => void): void {
    const onCountRef = useRef(onCount);
    onCountRef.current = onCount;

    useEffect(() => {
        if (!token) return;

        const socket = getNotificationSocket(token);

        const handleNewNotification = (payload: NewNotificationSocketPayload) => {
            const total = payload?.totalUnreadNotifications;
            if (typeof total === "number") {
                onCountRef.current(total);
            }
        };

        socket.on("new-notification", handleNewNotification);

        return () => {
            socket.off("new-notification", handleNewNotification);
        };
    }, [token]);
}
